import { get } from 'lodash';
export function getValueOrFallback(object, selector, fallback) {
    // note that we want to fallback when we get falsy value, like `''` or `'0'`
    return get(object, selector) || fallback;
}
//# sourceMappingURL=get-value-or-fallback.js.map